import * as React from 'react';
export const sofincoSvg = React.forwardRef(function sofincoSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M2.167 14.464H13.75V16H2.167v-1.536ZM7.786 0C4.183 0 1.5 2.733 1.5 6.107v.049c0 3.374 2.66 6.07 6.238 6.07 3.602 0 6.285-2.732 6.285-6.106v-.05c0-.616-.095-1.22-.262-1.777l-2.982 1.62c0 .062.012.134.012.194v.049c0 1.729-1.121 3.193-3.005 3.193-1.814 0-3.042-1.512-3.042-3.242V6.06c0-1.73 1.12-3.193 3.006-3.193.43 0 .834.085 1.192.242L11.96 1.5C10.874.556 9.432 0 7.786 0Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'm13.283.786-1.323.702-3.018 1.608-.632.338c-1.002.484-1.276.618-1.598.569l.656 1.512c.346.677.906.847 1.467.568L14.5 3.012V.144l-1.217.642Z',
    }),
  );
});
sofincoSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var sofinco = {
  category: 'paymentmethod',
  colorable: true,
  name: 'sofinco',
  svg: sofincoSvg,
};
